import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip'; // if you're using `tooltip`
import { InputTextModule } from 'primeng/inputtext'; // if using filters or input
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputSwitchModule } from 'primeng/inputswitch';

import { ChipModule } from 'primeng/chip';
import { TagModule } from 'primeng/tag';

import { SearchboxModule } from '@stantec/basin/searchbox';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { MenuModule } from 'primeng/menu';

import { StatusModule } from '@stantec/basin/status';

import { DataGridComponent } from './components/data-grid/data-grid.component';

import { SharedService } from './services/shared.service';

import { LottieAnimationPlayerModule } from '@stantec/basin/lottie-animation-player';
import { LottieModule, LottieCacheModule } from 'ngx-lottie';
import player from 'lottie-web';
import { LicenseDetailsComponent } from './components/license-details/license-details.component';
import { LicenseDetailsViewComponent } from './components/license-details-view/license-details-view.component';
import { AddUsersModalComponent } from './components/add-users-modal/add-users-modal.component';
import { StudyareaLogsComponent } from './components/studyarea-logs/studyarea-logs.component';
import { StudyareaRenewComponent } from './components/studyarea-renew/studyarea-renew.component';
import { DataGridLogsComponent } from './components/data-grid-logs/data-grid-logs.component';
import { AppDatePipe } from './pipes/app-date-pipe';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    DataGridComponent,
    LicenseDetailsComponent,
    LicenseDetailsViewComponent,
    StudyareaLogsComponent,
    StudyareaRenewComponent,
    DataGridLogsComponent,
    AppDatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TableModule,
    CardModule,
    ButtonModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    TabViewModule,
    SearchboxModule,
    DialogModule,
    PaginatorModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    ChipModule,
    TagModule,
    StatusModule,
    MenuModule,
    FormlyModule.forChild(),
    LottieAnimationPlayerModule,
    LottieModule.forRoot({ player: playerFactory }),
    LottieCacheModule.forRoot(),
    FormlyPrimeNGModule,
    InputSwitchModule,
    AddUsersModalComponent,
    LottieModule,
    LottieCacheModule
  ],
  exports: [
    CommonModule,
    DataGridComponent,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TableModule,
    CardModule,
    ButtonModule,
    DropdownModule,
    TooltipModule,
    InputTextModule,
    TabViewModule,
    SearchboxModule,
    DialogModule,
    PaginatorModule,
    DynamicDialogModule,
    ConfirmDialogModule,
    ChipModule,
    TagModule,
    StatusModule,
    MenuModule,
    FormlyPrimeNGModule,
    LottieAnimationPlayerModule,
    LottieModule,
    LottieCacheModule,
    FormlyModule,
    InputSwitchModule,
    LicenseDetailsComponent,
    LicenseDetailsViewComponent,
    DataGridLogsComponent,
    AppDatePipe
  ],
  providers: [DialogService, ConfirmationService, SharedService,DatePipe, AppDatePipe],
})
export class CommonSharedModule { }
